import axios from 'axios';
import configMap from '../config';
import devConfig from '../config/config.dev';
import prodConfig from '../config/config.prod';

// 根据当前 UMI 环境导出对应配置的 BASE_URL，若未配置则回退 dev/prod
const hasProcess = typeof process !== 'undefined' && process?.env;
const env = (hasProcess && process.env.UMI_ENV) || (hasProcess && process.env.NODE_ENV === 'production' ? 'prod' : 'dev');
const resolvedConfig = configMap || (env === 'prod' ? prodConfig : devConfig);
const BASE_URL = resolvedConfig?.define?.BASE_URL || resolvedConfig?.BASE_URL || '';

export function get(url, options = {}) {
  options.method = 'get';
  return send(url, options);
}

export function post(url, options = {}) {
  options.method = 'post';
  return send(url, options);
}

export function send(url, options = {}) {
  const { headers = {}, returnAll = false, toastError = true, timeout=6000, ...row } = options;
  let usrData = JSON.parse(localStorage.getItem('tenant-user') || '{}')
  console.log('usrData', usrData)
  // 动态配置token
  if (usrData.tokenValue) {
    headers[`${usrData?.tokenName}`] = `${usrData?.tokenValue}`
  }
  if (usrData?.tenantId) {
    headers['Tenant-Id'] = usrData?.tenantId
  }
  console.log('headers', headers)
  console.log('row', row)
  return axios.request(url.indexOf('http://') === 0 || url.indexOf('https://') === 0 ? url : (BASE_URL + url), {
    timeout,
    ...row,
    headers: {
      ...headers
    },
  }).then(res => {
    console.log(res);
    if(returnAll) {
      return res
    }
    const { code, msg, data } = res?.data;
    if (Number(code) == 0) {
      if (returnAll) {
        return res;
      } else {
        return data;
      }
    } else if (options.headers && options.headers['Content-Type'] === 'multipart/form-data') {  // 文件上传
      return Promise.resolve(res);
    } else {
      console.log(options);
      if (toastError) {
        // antdMessage.error(msg);
      }
      return Promise.reject(res);
    }
  }).catch(err => {
    console.error('err111',err);
    const { code, msg } = err?.data;
    // 401登录超时，403没权限
    if (code == 401) {
      // clearUserStorage();
      // antdMessage.error('对不起，请重新登录！');
      // history.push('/login');
      return Promise.reject({ code: -99991 });
    } else {
      // antdMessage.error(`网络请求失败${msg || ''}`);
      return Promise.reject(err);
    }
  });
}
